import React, { useState, useEffect, useCallback } from "react";

const PHOTOGRAPHY_DATA = [
  { id: 1, title: "Fashion Gallery", image: "/gallery/fashion.jpg", description: "Professional photo and video production services." },
  { id: 2, title: "Acting Gallery", image: "/gallery/acting.jpg", description: "Capturing unforgettable travel stories." },
  { id: 3, title: "Arts Gallery", image: "/gallery/arts.jpg", description: "Professional portrait photography." },
  { id: 4, title: "Wedding Gallery", image: "/gallery/wedding.jpg", description: "Creative wedding photography." },
  { id: 5, title: "Product Gallery", image: "/gallery/product.jpg", description: "Premium product photography." }
];

const ImageGallery3D = () => {
  const [active, setActive] = useState(2);

  const nextSlide = useCallback(() => {
    setActive((prev) => (prev + 1) % PHOTOGRAPHY_DATA.length);
  }, []);

  const prevSlide = useCallback(() => {
    setActive((prev) => (prev - 1 + PHOTOGRAPHY_DATA.length) % PHOTOGRAPHY_DATA.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 4000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const getPosition = (index) => {
    let diff = index - active;
    if (diff < -2) diff += PHOTOGRAPHY_DATA.length;
    if (diff > 2) diff -= PHOTOGRAPHY_DATA.length;
    return diff;
  };

  return (
    <section className="photo-section" style={{ backgroundImage: 'url(/arts/khultstudio-arts-bgc1.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', minHeight: '400px' }}>
      <div className="cards-wrapper"> 
        {PHOTOGRAPHY_DATA.map((item, index) => {
          const pos = getPosition(index);
          const transforms = {
            0: "translateX(0px) scale(1.1)",
            1: "translateX(280px) rotate(15deg)",
            "-1": "translateX(-280px) rotate(-15deg)",
            2: "translateX(520px) rotate(25deg)",
            "-2": "translateX(-520px) rotate(-25deg)",
          };

          return (
            <div
              key={item.id}
              className={`photo-card ${pos === 0 ? "active" : ""}`}
              style={{
                transform: transforms[pos] || "scale(0)",
                zIndex: 5 - Math.abs(pos),
                opacity: Math.abs(pos) > 2 ? 0 : 1
              }}
            >
              <img src={item.image} alt={item.title} />
              <div className="gradient"></div>
              <h3>{item.title}</h3>
            </div>
          );
        })}
      </div>

      <div className="fixed-content-area">
        <p className="description-text">{PHOTOGRAPHY_DATA[active].description}</p>
        <button className="read-btn">Read More →</button>
        <div className="nav-controls">
          <button onClick={prevSlide} className="nav-arrow">❮</button>
          <button onClick={nextSlide} className="nav-arrow">❯</button>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery3D;